import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { Colors, Fonts, Metrics } from '../../Themes'

const propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  grey: PropTypes.bool,
  success: PropTypes.bool,
  cancel: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  fullWidth: PropTypes.bool,
  link: PropTypes.bool
}

const ButtonContainer = styled.button`
  ${Fonts.style.Button};
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
  display: inline-block;
  border: 1px solid ${props =>
    props.disabled ||
    props.grey ||
    props.success ||
    props.cancel ||
    props.primary ||
    props.secondary ||
    props.link
      ? 'transparent'
      : Colors.primary};
      border-radius: 0;
  padding: ${Metrics.margins.small} ${Metrics.margins.large};
  background: ${props => {
    if (props.disabled) {
      return Colors.lightGrey
    }
    if (props.grey) {
      return Colors.darkGrey
    }
    if (props.success) {
      return Colors.greenBlue
    }
    if (props.cancel) {
      return Colors.red
    }
    if (props.primary) {
      return Colors.primary
    }
    if (props.secondary) {
      return Colors.black
    }
    return 'transparent'
  }};
  cursor: pointer;
  color: ${props =>
    props.disabled ||
    props.grey ||
    props.success ||
    props.cancel ||
    props.primary ||
    props.secondary
      ? Colors.white
      : props.link ? Colors.black : Colors.primary};
  outline: none;
  text-transform: uppercase;
  pointer-events: ${props => (props.disabled ? 'none' : 'inherit')};

  &:hover{
    border: 1px solid ${props => {
      if (props.disabled) {
        return Colors.lightGrey
      }
      if (props.grey) {
        return Colors.darkGrey
      }
      if (props.success) {
        return Colors.greenBlue
      }
      if (props.cancel) {
        return Colors.red
      }
      if (props.primary) {
        return Colors.primary
      }
      if (props.secondary) {
        return Colors.black
      }
      return 'transparent'
    }};
    border-radius: 0;
    background: ${props =>
      props.disabled ||
      props.grey ||
      props.success ||
      props.cancel ||
      props.secondary ||
      props.link
        ? 'transparent'
        : Colors.primary};
    color: ${props => {
      if (props.disabled) {
        return Colors.lightGrey
      }
      if (props.grey) {
        return Colors.darkGrey
      }
      if (props.success) {
        return Colors.greenBlue
      }
      if (props.cancel) {
        return Colors.red
      }
      if (props.secondary) {
        return Colors.black
      }
      if (props.link) {
        return Colors.darkgrey
      }
      return Colors.white
    }}
`

const Button = props => {
  const { label, onClick } = props

  return (
    <ButtonContainer onTap={onClick} {...props}>
      {label}
    </ButtonContainer>
  )
}

Button.propTypes = propTypes

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js